import { isEmpty } from 'lodash';
import {
  AddSaveBrokerDto,
  AddressDto,
  BillingAddressDto,
  ContactDto,
  ManualLegDto,
  ReferenceRouteFormDto,
} from '../types';

export const isValidationValidated = (validationState: any) => {
  let valid = true;
  for (const property in validationState) {
    if (!validationState[property]) {
      valid = false;
      break;
    }
  }
  return valid;
};
export const isValidEmail = (email: string) => {
  const validEmail = new RegExp(
    '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+[.]{1}[a-zA-Z]{2,}$'
  );
  return validEmail.test(email);
};
export const isStrongPassword = (password: string) => {
  if (password.length < 14) {
    return false;
  }
  if (/^\d+$/.test(password)) {
    return false;
  }
  if ((password.match(/[A-Z]/g) || []).length < 2) {
    return false;
  }
  if ((password.match(/[!@#$%^&*;:.-]/g) || []).length < 2) {
    return false;
  }
  return true;
};
export function mapLineChartData(data: any) {
  const labels = data?.months;
  let backgroundColor = [
    'rgba(179, 124, 196, 0.65)',
    'rgba(175, 209, 0, 0.65)',
    'rgba(0, 178, 177, 0.65)',
    'rgba(37, 17, 99, 0.65)',
    'rgba(149, 140, 131, 0.65)',
  ];
  const datasets = data?.years?.map((year: any, index: any) => ({
    label: year.year,
    data: year.month_data,
    borderColor: backgroundColor[index],
    backgroundColor: backgroundColor[index],
  }));

  return { labels, datasets };
}
export function mapPolarChartData(data: any) {
  const labels = ['Air', 'Courier', 'LTL', 'FTL', 'Sea'];
  let backgroundColor = [
    'rgba(179, 124, 196, 0.65)',
    'rgba(175, 209, 0, 0.65)',
    'rgba(0, 178, 177, 0.65)',
    'rgba(37, 17, 99, 0.65)',
    'rgba(149, 140, 131, 0.65)',
  ];
  let values = [
    data?.air_legs,
    data?.courier_legs,
    data?.ltl_legs,
    data?.ftl_legs,
    data?.sea_legs,
  ];

  let datasets: any = [
    {
      labels: labels,
      data: values,
      backgroundColor: backgroundColor,
      borderWidth: 1,
    },
  ];

  return { labels, datasets };
}
export function mapPieChartData(data: any) {
  const labels = ['Air', 'Courier', 'LTL', 'FTL', 'Sea'];
  let backgroundColor = [
    'rgba(179, 124, 196, 0.65)',
    'rgba(175, 209, 0, 0.65)',
    'rgba(0, 178, 177, 0.65)',
    'rgba(37, 17, 99, 0.65)',
    'rgba(149, 140, 131, 0.65)',
  ];
  let values = [
    data?.air_spend === '0.00' ? 0 : (data?.air_spend / data?.spend) * 100,
    data?.courier_spend === '0.00'
      ? 0
      : (data?.courier_spend / data?.spend) * 100,
    data?.ltl_spend === '0.00' ? 0 : (data?.ltl_spend / data?.spend) * 100,
    data?.ftl_spend === '0.00'
      ? 0
      : (data?.ftl_spend_spend / data?.spend) * 100,
    data?.sea_spend === '0.00'
      ? 0
      : (data?.sea_spend_spend / data?.spend) * 100,
  ];

  let datasets: any = [
    {
      labels: labels,
      data: values,
      backgroundColor: backgroundColor,
      borderWidth: 1,
    },
  ];

  return { labels, datasets };
}
export function formatDateToYYMMDD(date: Date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}
export function formatDateWithDashes(date: Date | null) {
  if (!date) {
    return '';
  }
  let month = '' + (date.getMonth() + 1);
  let day = '' + date.getDate();

  if (month.length < 2) {
    month = '0' + month;
  }

  if (day.length < 2) {
    day = '0' + day;
  }

  return `${date.getFullYear()}-${month}-${day}`;
}

export function formatDateWithFS(date: Date) {
  let month = '' + (date.getMonth() + 1);
  let day = '' + date.getDate();

  if (month.length < 2) {
    month = '0' + month;
  }

  if (day.length < 2) {
    day = '0' + day;
  }

  return `${date.getFullYear()}/${month}/${day}`;
}

export function formatDateWithISO(date: any) {
  const { dateInstance } = date;
  const dateObject = new Date(dateInstance);
  const isoString = dateObject.toISOString();
  return isoString;
}

export function getHourFromISOString(date: any) {
  let hour = '-1';
  if (date && date !== '') {
    hour = date.split('T')[1].split('.')[0].split(':')[0];
  }

  return hour;
}

export function getMinFromISOString(date: any) {
  let min = '-1';
  if (date && date !== '') {
    min = date.split('T')[1].split('.')[0].split(':')[1];
  }

  return min;
}

export function formatDate(date: Date | string | null) {
  // const options = { year: 'numeric', month: 'long', day: 'numeric' };
  // return new Intl.DateTimeFormat('en-US', options).format(date);
  if (!date) {
    return '';
  }
  const dateObject = new Date(date);
  const formattedDate = dateObject.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
  return formattedDate;
}

export function mapAddLegPayloadForRatesQuote(
  destinationFormContextData: AddressDto,
  originFormContextData: AddressDto,
  selectedCarriersContext: any,
  packages: any,
  referenceFormDataContext: ReferenceRouteFormDto,
  isFood: any
) {
  let payload = {
    origin: {
      address: originFormContextData.address,
      city: originFormContextData.city,
      province: originFormContextData.province,
      country: originFormContextData.country,
      postal_code: originFormContextData.postal_code,
      has_shipping_bays: originFormContextData.has_shipping_bays,
      is_residential: !originFormContextData.has_shipping_bays,
    },
    destination: {
      address: destinationFormContextData.address,
      city: destinationFormContextData.city,
      province: destinationFormContextData.province,
      country: destinationFormContextData.country,
      postal_code: destinationFormContextData.postal_code,
      has_shipping_bays: destinationFormContextData.has_shipping_bays,
      is_residential: !destinationFormContextData.has_shipping_bays,
    },
    packages: packages,
    is_food: isFood,
    is_metric: true,
    quote_email: '',
    carrier_options: selectedCarriersContext ? selectedCarriersContext : [],
    booking_date: formatDateWithDashes(
      new Date(referenceFormDataContext?.booking_date)
    ),
  };
  return payload;
}

export function mapPayloadForRatesQuote(
  destinationFormContextData: AddressDto,
  originFormContextData: AddressDto,
  selectedCarriersContext: any,
  packagesList: any,
  isFood: boolean,
  isMetric: boolean,
  referenceFormDataContext?: ReferenceRouteFormDto
) {
  let packages: any = [];
  for (let i = 0; i < packagesList.length; i++) {
    packages.push({
      item_id: packagesList[i]?.id,
      package_type: packagesList[i]?.package_type?.toUpperCase(),
      package_description: packagesList[i]?.package_description,
      description: packagesList[i]?.description,
      quantity: Number(packagesList[i]?.quantity),
      length: Number(packagesList[i]?.length),
      width: Number(packagesList[i]?.width),
      height: Number(packagesList[i]?.height),
      weight: Number(packagesList[i]?.weight),
      nog_id: packagesList[i]?.nog_id,
      units: isMetric ? '0' : '1',
      is_metric: isMetric,
      freight_class:
        packagesList[i]?.freight_class !== '-1'
          ? packagesList[i]?.freight_class
          : undefined,
      package_id: packagesList[i]?.package_id,
      id: packagesList[i]?.id,
      is_dangerous_good: packagesList[i]?.is_dangerous_good,
      is_cos: packagesList[i]?.is_cos,
      is_pharma: packagesList[i]?.is_pharma,
      time_sensitive_hours: packagesList[i]?.time_sensitive_hours,
      is_time_sensitive: packagesList[i]?.is_time_sensitive,
      un_number: packagesList[i]?.is_dangerous_good
        ? packagesList[i]?.un_number
        : undefined,
      dg_nos_description: packagesList[i]?.is_nos
        ? packagesList[i]?.dg_nos_description
        : '',
      dg_neq_description: packagesList[i]?.is_neq
        ? packagesList[i]?.dg_neq_description
        : undefined,
      dg_quantity: packagesList[i]?.is_dangerous_good
        ? packagesList[i]?.dg_quantity
        : undefined,
      is_nos: packagesList[i]?.is_dangerous_good
        ? packagesList[i]?.is_nos
        : undefined,
      is_neq: packagesList[i]?.is_dangerous_good
        ? packagesList[i]?.is_neq
        : undefined,
      proper_shipping_name: packagesList[i]?.is_dangerous_good
        ? packagesList[i]?.proper_shipping_name
        : undefined,
      packing_group_name: packagesList[i]?.is_dangerous_good
        ? packagesList[i]?.packing_group_name
        : undefined,
      packing_group: packagesList[i]?.is_dangerous_good
        ? packagesList[i]?.packing_group
        : undefined,
      packing_type: packagesList[i]?.is_dangerous_good
        ? packagesList[i]?.packing_type
        : undefined,
      packing_type_name: packagesList[i]?.is_dangerous_good
        ? packagesList[i]?.packing_type_name
        : undefined,
      year: packagesList[i]?.year,
      make: packagesList[i]?.make,
      model: packagesList[i]?.model,
      vin: packagesList[i]?.vin,
      condition: packagesList[i]?.condition,
      anti_theft: packagesList[i]?.anti_theft,
      container_number:
        packagesList[i]?.package_description !== 'Container'
          ? packagesList[i]?.container_number
          : undefined,
      status_name:
        packagesList[i]?.package_description !== 'Container'
          ? undefined
          : packagesList[i]?.status_name,
      commodities: packagesList[i]?.commodities,
    });
  }
  let payload = {
    origin: {
      address: originFormContextData.address,
      city: originFormContextData.city,
      province: originFormContextData.province,
      country: originFormContextData.country,
      postal_code: originFormContextData.postal_code,
      has_shipping_bays: originFormContextData.has_shipping_bays,
      is_residential: !originFormContextData.has_shipping_bays,
    },
    destination: {
      address: destinationFormContextData.address,
      city: destinationFormContextData.city,
      province: destinationFormContextData.province,
      country: destinationFormContextData.country,
      postal_code: destinationFormContextData.postal_code,
      has_shipping_bays: destinationFormContextData.has_shipping_bays,
      is_residential: !destinationFormContextData.has_shipping_bays,
    },
    packages: packages,
    is_food: isFood,
    is_metric: isMetric,
    quote_email: '',
    carrier_options: selectedCarriersContext ? selectedCarriersContext : [],
    booking_date:
      referenceFormDataContext &&
      formatDateWithDashes(new Date(referenceFormDataContext?.booking_date)),
  };
  return payload;
}
export function mapPayloadForRequestQuote(
  ratesPayload: any,
  shipperFormData: ContactDto,
  consigneeFormData: ContactDto,
  referenceFormDataContext?: ReferenceRouteFormDto
) {
  let payload = {
    origin: {
      address: ratesPayload?.origin?.address,
      city: ratesPayload?.origin?.city,
      province: ratesPayload?.origin?.province,
      country: ratesPayload?.origin?.country,
      postal_code: ratesPayload?.origin?.postal_code,
      has_shipping_bays: ratesPayload?.origin?.has_shipping_bays,
      is_residential: ratesPayload?.origin?.is_residential,
      company_name: shipperFormData?.company_name,
      name: shipperFormData?.name,
      phone: shipperFormData?.phone,
      email: shipperFormData?.email,
    },
    destination: {
      address: ratesPayload?.destination?.address,
      city: ratesPayload?.destination?.city,
      province: ratesPayload?.destination?.province,
      country: ratesPayload?.destination?.country,
      postal_code: ratesPayload?.destination?.postal_code,
      has_shipping_bays: ratesPayload?.destination?.has_shipping_bays,
      is_residential: ratesPayload?.destination?.is_residential,
      company_name: consigneeFormData?.company_name,
      name: consigneeFormData?.name,
      phone: consigneeFormData?.phone,
      email: consigneeFormData?.email,
    },
    packages: ratesPayload?.packages,
    is_food: ratesPayload?.is_food,
    is_metric: ratesPayload?.is_metric,
    email: ratesPayload?.quote_email,
    carrier_options: ratesPayload?.carrier_options,
    booking_date:
      referenceFormDataContext &&
      formatDateWithDashes(new Date(referenceFormDataContext?.booking_date)),
  };
  return payload;
}
export function mapPayloadForRequestQuoteMultileg(
  addLegShipmentDataContext: any,
  addLegShipmentPackagesContext: any,
  multiLegListContext: any,
  ratesPayload: any,
  legIndex: number
) {
  let payload = {
    origin: {
      address: multiLegListContext[legIndex]?.origin?.address,
      city: multiLegListContext[legIndex]?.origin?.city,
      province: multiLegListContext[legIndex]?.origin?.province,
      country: multiLegListContext[legIndex]?.origin?.country,
      postal_code: multiLegListContext[legIndex]?.origin?.postal_code,
      has_shipping_bays:
        multiLegListContext[legIndex]?.origin?.has_shipping_bays,
      is_residential: multiLegListContext[legIndex]?.origin?.is_residential,
      company_name: multiLegListContext[legIndex]?.shipper?.company_name,
      name: multiLegListContext[legIndex]?.shipper?.name,
      phone: multiLegListContext[legIndex]?.shipper?.phone,
      email: multiLegListContext[legIndex]?.shipper?.email,
    },
    destination: {
      address: multiLegListContext[legIndex]?.destination?.address,
      city: multiLegListContext[legIndex]?.destination?.city,
      province: multiLegListContext[legIndex]?.destination?.province,
      country: multiLegListContext[legIndex]?.destination?.country,
      postal_code: multiLegListContext[legIndex]?.destination?.postal_code,
      has_shipping_bays:
        multiLegListContext[legIndex]?.destination?.has_shipping_bays,
      is_residential:
        multiLegListContext[legIndex]?.destination?.is_residential,
      company_name: multiLegListContext[legIndex]?.consignee?.company_name,
      name: multiLegListContext[legIndex]?.consignee?.name,
      phone: multiLegListContext[legIndex]?.consignee?.phone,
      email: multiLegListContext[legIndex]?.consignee?.email,
    },
    packages: addLegShipmentPackagesContext,
    is_food: addLegShipmentDataContext?.is_food,
    is_metric: addLegShipmentDataContext?.is_metric,
    email: ratesPayload?.quote_email,
    carrier_options: multiLegListContext[legIndex]?.carrier_options,
    booking_date: '2024-05-09',
  };
  return payload;
}
export function calculateInsuranceCost(value: any) {
  let zero = 0.0;
  let min = 15.0;
  let floatValue = value !== '' ? parseFloat(value) : zero;
  if (floatValue === zero) {
    return;
  }
  let insurance_cost = floatValue * 0.003;

  if (insurance_cost < min) {
    insurance_cost = min;
  }
  return insurance_cost.toFixed(2);
}

export function mapShipPayloadData(
  ratesApiPayloadContext: any,
  ratesApiDataContext: any,
  referenceFormDataContext: ReferenceRouteFormDto,
  shipperFormData: ContactDto,
  consigneeFormData: ContactDto,
  specialInstructionContext: string,
  monerisToken: string | undefined,
  pickupPayloadContext: any,
  selectedRateContext: any,
  isBillingAddressSame: boolean,
  billingForm: BillingAddressDto | undefined,
  shippingDocsContext: any,
  servicesDataContext: any,
  bc_fields?: any,
  account_number?: any,
  selectedManualLegsContext?: ManualLegDto[],
  brokerFormDataContext?: AddSaveBrokerDto,
  quote_id?: any,
  selectedJob?: string,
  shipment_id?: string,
  allCommoditiesContext?: any,
  finalCostContext?:any,
  bc_customer_code?:any,
  bc_customer_name?:any,

) {
  let isPickup = pickupPayloadContext ? pickupPayloadContext?.is_pickup : false;
  return {
    rate_id: ratesApiDataContext?.content?.rate_id,
    gateway_number: selectedJob && selectedJob !== '' ? selectedJob : undefined,
    service: servicesDataContext,
    origin: {
      address: ratesApiPayloadContext?.origin?.address,
      city: ratesApiPayloadContext?.origin?.city,
      province: ratesApiPayloadContext?.origin?.province,
      country: ratesApiPayloadContext?.origin?.country,
      postal_code: ratesApiPayloadContext?.origin?.postal_code,
      has_shipping_bays: ratesApiPayloadContext?.origin?.has_shipping_bays,
      is_residential: ratesApiPayloadContext?.origin?.is_residential,
      company_name: shipperFormData?.company_name,
      name: shipperFormData?.name,
      phone: shipperFormData?.phone,
      email: shipperFormData?.email,
    },
    destination: {
      address: ratesApiPayloadContext?.destination?.address,
      city: ratesApiPayloadContext?.destination?.city,
      province: ratesApiPayloadContext?.destination?.province,
      country: ratesApiPayloadContext?.destination?.country,
      postal_code: ratesApiPayloadContext?.destination?.postal_code,
      has_shipping_bays: ratesApiPayloadContext?.destination?.has_shipping_bays,
      is_residential: ratesApiPayloadContext?.destination?.is_residential,
      company_name: consigneeFormData?.company_name,
      name: consigneeFormData?.name,
      phone: consigneeFormData?.phone,
      email: consigneeFormData?.email,
    },
    billing: {
      address: isBillingAddressSame
        ? ratesApiPayloadContext?.origin?.address
        : billingForm?.address,
      city: isBillingAddressSame
        ? ratesApiPayloadContext?.origin?.city
        : billingForm?.city,
      province: isBillingAddressSame
        ? ratesApiPayloadContext?.origin?.province
        : billingForm?.province,
      country: isBillingAddressSame
        ? ratesApiPayloadContext?.origin?.country
        : billingForm?.country,
      postal_code: isBillingAddressSame
        ? ratesApiPayloadContext?.origin?.postal_code
        : billingForm?.postal_code,
      has_shipping_bays: ratesApiPayloadContext?.origin?.has_shipping_bays,
      is_residential: ratesApiPayloadContext?.origin?.is_residential,
      company_name: isBillingAddressSame
        ? shipperFormData?.company_name
        : billingForm?.company,
      name: isBillingAddressSame ? shipperFormData?.name : billingForm?.name,
      phone: isBillingAddressSame ? shipperFormData?.phone : billingForm?.phone,
      email: isBillingAddressSame ? shipperFormData?.email : billingForm?.email,
    },
    packages: ratesApiPayloadContext?.packages,
    reference_one: referenceFormDataContext?.reference_1,
    reference_two: referenceFormDataContext?.reference_2,
    project: referenceFormDataContext?.project_name,
    special_instructions: specialInstructionContext
      ? specialInstructionContext
      : '',
    is_food: ratesApiPayloadContext?.is_food,
    is_metric: ratesApiPayloadContext?.is_metric,
    carrier_options: ratesApiPayloadContext?.carrier_options,
    is_declared_dangerous_goods: false,
    is_pickup: isPickup,
    pickup:
      pickupPayloadContext && pickupPayloadContext?.is_pickup
        ? {
            date: pickupPayloadContext?.date,
            start_time: pickupPayloadContext?.start_time,
            end_time: pickupPayloadContext?.end_time,
          }
        : undefined,
    moneris_token: monerisToken,
    quote_id: quote_id ? quote_id : undefined,
    booking_date: formatDateWithDashes(
      new Date(referenceFormDataContext?.booking_date)
    ),
    documents: shippingDocsContext,
    bc_fields: bc_fields ? bc_fields : undefined,
    account_number: account_number ? account_number : undefined,
    legs: selectedManualLegsContext,
    freight:
      selectedManualLegsContext || (shipment_id && shipment_id !== '')
        ? 0
        : undefined,
    surcharge:
      selectedManualLegsContext || (shipment_id && shipment_id !== '')
        ? 0
        : undefined,
    tax:
      selectedManualLegsContext || (shipment_id && shipment_id !== '')
        ? 0
        : undefined,
    cost:
      selectedManualLegsContext || (shipment_id && shipment_id !== '')
        ? 0
        : undefined,
    shipment_id: shipment_id && shipment_id !== '' ? shipment_id : undefined,
    broker: brokerFormDataContext && {
      address: brokerFormDataContext?.address?.address,
      // address_two: brokerFormDataContext?.address?.address_two,
      city: brokerFormDataContext?.address?.city,
      province: brokerFormDataContext?.address?.province,
      country: brokerFormDataContext?.address?.country,
      postal_code: brokerFormDataContext?.address?.postal_code,
      has_shipping_bays: brokerFormDataContext?.address?.has_shipping_bays,
      company_name: brokerFormDataContext?.contact?.company_name,
      name: brokerFormDataContext?.contact?.name,
      phone: brokerFormDataContext?.contact?.phone,
      email: brokerFormDataContext?.contact?.email,
    },
    commodities: allCommoditiesContext ? allCommoditiesContext : undefined,
    insurance_amount: finalCostContext && finalCostContext?. insuranceField !== "" ? finalCostContext?.insuranceField : 0,
    bc_customer_code: bc_customer_code ? bc_customer_code : undefined,
    bc_customer_name: bc_customer_name ? bc_customer_name : undefined,

  };
}
export const filterTimesObj = (
  timesArray: string[],
  start: string,
  end: string
) => {
  return timesArray.filter((time: string) => {
    const currentTime = new Date(`2000-01-01T${time}`);
    const startTime = new Date(`2000-01-01T${start}`);
    const endTime = new Date(`2000-01-01T${end}`);

    return currentTime >= startTime && currentTime <= endTime;
  });
};
export function formatTime(timestamp: any) {
  const dateObject = new Date(timestamp);
  const hours = dateObject.getHours().toString().padStart(2, '0');
  const minutes = dateObject.getMinutes().toString().padStart(2, '0');
  const formattedTime = `${hours}:${minutes}`;
  return formattedTime;
}
export function formatFiveTime(timestamp: any) {
  const dateObject = new Date(timestamp);
  const hours = (dateObject.getUTCHours() + 5).toString().padStart(2, '0');
  const minutes = dateObject.getUTCMinutes().toString().padStart(2, '0');
  const formattedTime = `${hours}:${minutes}`;
  return formattedTime;
}
export function clearLocalStorage() {
  localStorage.removeItem('selectedATALegsInfo');
  localStorage.removeItem('originFormData');
  localStorage.removeItem('destinationFormData');
  localStorage.removeItem('shipperFormData');
  localStorage.removeItem('consigneeFormData');
  localStorage.removeItem('carrierOptionsContext');
  localStorage.removeItem('routeFormValidationContext');
  localStorage.removeItem('ratesApiDataContext');
  localStorage.removeItem('ratesApiPayloadContext');
  localStorage.removeItem('referenceFormDataContext');
  localStorage.removeItem('specialInstructionContext');
  localStorage.removeItem('pickupValidateDataContext');
  localStorage.removeItem('pickupTimezoneDataContext');
  localStorage.removeItem('selectedRateContext');
  localStorage.removeItem('finalRateContext');
  localStorage.removeItem('pickupPayloadContext');
  localStorage.removeItem('shippingDocsContext');
  localStorage.removeItem('selectedPlanningLaneContext');
  localStorage.removeItem('selectedServiceContext');
  localStorage.removeItem('selectedAccountContext');
  localStorage.removeItem('selectedJobContext');
  localStorage.removeItem('selectedManualLegsContext');
  localStorage.removeItem('brokerFormDataContext');
  localStorage.removeItem('isMetricContext');
  localStorage.removeItem('savedQuoteFormDataContext');
  localStorage.removeItem('addLegShipmentDataContext');
  localStorage.removeItem('addLegShipmentPackagesContext');
  localStorage.removeItem('allCommoditiesContext');
  localStorage.removeItem('multiLegListContext');
  localStorage.removeItem('totalLegsContext');
  localStorage.removeItem('selectedMultiLegRateContext');
  localStorage.removeItem('ratesMultiLegApiDataContext');
}
export const mapAPIsInCategories = (categoriesMapping: any, apiList: any) => {
  const mappedData: any = [];

  Object.entries(categoriesMapping).forEach(([categoryCode, categoryName]) => {
    const categoryData = apiList.filter(
      (api: any) => api.category === categoryCode
    );

    if (categoryData.length > 0) {
      mappedData.push({
        category: categoryName,
        data: categoryData,
      });
    }
  });

  return mappedData;
};
export const getCategoryName = (categoriesMapping: any, name: string) => {
  if (categoriesMapping.hasOwnProperty(name)) {
    return categoriesMapping[name];
  } else {
    return 'Unknown Category';
  }
};
export const getDocumentName = (docsTypes: any, type: string) => {
  const foundType = docsTypes.find((docType: any) => docType.value === type);

  if (foundType) {
    return foundType.name;
  } else {
    return 'Type not found';
  }
};

export const removeNullProperties = (obj: any) => {
  for (const key in obj) {
    if (obj[key] === null) {
      delete obj[key];
    } else if (typeof obj[key] === 'object') {
      removeNullProperties(obj[key]);
      if (Object.keys(obj[key]).length === 0) {
        delete obj[key];
      }
    }
  }
  return obj;
};

export const sortedRatesTableData = (
  filteredRateArray: any[],
  sortColumn: string,
  sortOrder: string
) => {
  if (!filteredRateArray || filteredRateArray.length === 0) {
    return [];
  }

  const column = sortColumn;
  const sorted = [...filteredRateArray].sort((a, b) => {
    if (column === 'total') {
      const valueA = parseFloat(a.rate.total) - parseFloat(a.rate.tax);
      const valueB = parseFloat(b.rate.total) - parseFloat(b.rate.tax);

      return sortOrder === 'asc' ? valueA - valueB : valueB - valueA;
    } else if (column === 'carrier_name') {
      const valueA = a.routing[0].carrier_name.toLowerCase();
      const valueB = b.routing[0].carrier_name.toLowerCase();

      if (typeof valueA === 'string' && typeof valueB === 'string') {
        return sortOrder === 'asc'
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      }

      return sortOrder === 'asc' ? valueA - valueB : valueB - valueA;
    } else {
      const valueA = a[column];
      const valueB = b[column];

      if (typeof valueA === 'string' && typeof valueB === 'string') {
        return sortOrder === 'asc'
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      }

      return sortOrder === 'asc' ? valueA - valueB : valueB - valueA;
    }
  });

  return sorted;
};

export function mapServiceInfoForMultiLeg(
  legList: any,
  mappedRouting: any,
  username: any,
  multiLegSelectedRates: any
) {
  let service: any = [];
  for (let i = 0; i < legList.length; i++) {
    console.log('hhhhhh', multiLegSelectedRates[i]);
    service.push({
      shipment: {
        mode_code: 'DIR',
        routing: [mappedRouting[i]],
      },
      rate_id: multiLegSelectedRates[i]?.rate_id,
      is_pickup: false,
      booking_date: formatDateWithDashes(new Date()),
      origin: {
        address: legList[i]?.origin?.address,
        city: legList[i]?.origin?.city,
        province: legList[i]?.origin?.province,
        country: legList[i]?.origin?.country,
        postal_code: legList[i]?.origin?.postal_code,
        has_shipping_bays: legList[i]?.origin?.has_shipping_bays,
        is_residential: !legList[i]?.origin?.has_shipping_bays,
        company_name: legList[i]?.shipper?.company_name,
        name: legList[i]?.shipper?.name,
        phone: legList[i]?.shipper?.phone,
        email: legList[i]?.shipper?.email,
      },
      destination: {
        address: legList[i]?.destination?.address,
        city: legList[i]?.destination?.city,
        province: legList[i]?.destination?.province,
        country: legList[i]?.destination?.country,
        postal_code: legList[i]?.destination?.postal_code,
        has_shipping_bays: legList[i]?.destination?.has_shipping_bays,
        is_residential: !legList[i]?.destination?.has_shipping_bays,
        company_name: legList[i]?.consignee?.company_name,
        name: legList[i]?.consignee?.name,
        phone: legList[i]?.consignee?.phone,
        email: legList[i]?.consignee?.email,
      },
      special_instructions: legList[i]?.special_instructions
        ? legList[i]?.special_instructions
        : '',

      carrier_options: legList[i]?.carrier_options
        ? legList[i]?.carrier_options
        : [],
      username: username,
      email: username,
    });
  }
  return service;
}

export const isExcelFile = (file: File): boolean => {
  const mimeType = file.type;
  const fileName = file.name.toLowerCase();

  const excelMimeTypes = [
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ];

  const excelExtensions = ['.xls', '.xlsx'];

  const isExcelMimeType = excelMimeTypes.includes(mimeType);

  const isExcelExtension = excelExtensions.some((ext) =>
    fileName.endsWith(ext)
  );

  return isExcelMimeType || isExcelExtension;
};

interface IOptions{
  value: string | number;
  name: string | number;
  id:string | number;
}
 
export const getValueFromOption = (value: any, options:IOptions[]): string => {
  if (isEmpty(options)) {
    return value;
  }
 
  const option = options.find((option) => option.name === value);
  return option ? option.value : value;
};